module.exports = __webpack_public_path__ + "img/installmentHead.571460bb.png";